module.exports = __webpack_public_path__ + "static/media/home-icon-white.7d166a23.svg";